import {Component, Input} from '@angular/core';
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";

@Component({
  selector: 'app-org-user-profile-modal',
  templateUrl: './org-user-profile-modal.component.pug',
  styleUrls: ['./org-user-profile-modal.component.scss'],
  standalone: false
})
export class OrgUserProfileModalComponent {
  @Input() user: any;


  constructor(public modalService: BsModalService, public modalRef: BsModalRef) {

  }

  ngOnInit() {
    if (this.user){
          this.user.invitation_accepted = !!this.user?.first_name
    }
  }

  measureTextWidth(text: string): number {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (context) {
      context.font = '14px Arial';
      return context.measureText(text).width;
    }
    return 0;
  }

  getTeamsString() {
    const maxLength = 25;
    const divWidth = 240;
    const suffix = '...';
    const suffixWidth = this.measureTextWidth(suffix);

    if (this.user.teams.length === 0) {
      return '-';
    }

    // Truncate team names longer than maxLength or exceeding divWidth
    const truncatedTeams = this.user.teams.map(team => {
      const teamNameWidth = this.measureTextWidth(team.name);
      return teamNameWidth > divWidth
        ? team.name.slice(0, maxLength) + suffix
        : team.name;
    });

    const hasLongName = truncatedTeams.some(name => name.endsWith(suffix));

    if (this.user.teams.length === 1) {
      const teamName = this.user.teams[0].name;
      const textWidth = this.measureTextWidth(teamName);

      if (textWidth > divWidth) {
        let sliceWidth = Math.floor(divWidth / (textWidth / teamName.length));
        let truncatedName = teamName.slice(0, sliceWidth) + suffix;

        while (this.measureTextWidth(truncatedName) > divWidth) {
          sliceWidth--;
          truncatedName = teamName.slice(0, sliceWidth) + suffix;
        }

        return truncatedName;
      }
    }

    if (!hasLongName) {
      if (this.user.teams.length > 3) {
        const visibleTeams = truncatedTeams.slice(0, 3).join(', ');
        if (this.user.teams.length > 3) {
          const displayTeams = truncatedTeams.slice(0, 2).join(', ');
          return `${displayTeams}, +${this.user.teams.length - 2} more`;
        }
        return `${visibleTeams}, +${this.user.teams.length - 3} more`;
      } else if (truncatedTeams.join(', ').length > maxLength) {
        const visibleTeams = truncatedTeams.slice(0, 2).join(', ');
        if (visibleTeams.length > maxLength) {
          const displayTeams = truncatedTeams[0];
          return `${displayTeams}, +${this.user.teams.length - 1} more`;
        }
        return `${visibleTeams}, +${this.user.teams.length - 2} more`;
      }
      return truncatedTeams.join(', ');
    }

    // Handle case where at least one team name is truncated
    const firstTeamName = truncatedTeams[0];
    if (this.user.teams.length > 1) {
      const combinedString = `${firstTeamName} +${this.user.teams.length - 1} more`;

      // Determine if we need to add a comma based on truncation of the first team name
      const firstTeamTruncated = firstTeamName.endsWith(suffix);

      if (this.measureTextWidth(combinedString) > divWidth) {
        let sliceWidth = Math.floor(divWidth / (this.measureTextWidth(firstTeamName) / firstTeamName.length));
        let truncatedName = firstTeamName.slice(0, sliceWidth) + suffix;

        while (this.measureTextWidth(truncatedName + ` +${this.user.teams.length - 1} more`) > divWidth) {
          sliceWidth--;
          truncatedName = firstTeamName.slice(0, sliceWidth) + suffix;
        }

        return firstTeamTruncated
          ? `${truncatedName} +${this.user.teams.length - 1} more`
          : `${truncatedName}, +${this.user.teams.length - 1} more`;
      } else {
        return firstTeamTruncated
          ? `${firstTeamName} +${this.user.teams.length - 1} more`
          : `${firstTeamName}, +${this.user.teams.length - 1} more`;
      }
    }

    return firstTeamName;
  }

  checkOverflowHeight(element: any): boolean {
    return element.offsetHeight < element.scrollHeight;
  }

  checkOverflow(element: any): boolean {
    return element.offsetWidth < element.scrollWidth;
  }

  getRolesString(user: { roles?: { role: string } }): string {
    if (!user.roles) {
      return '-';
    }

    const roleMapping: { [key: string]: string } = {
      member: 'Member',
      owner: 'Owner',
      support: 'Xref Support',
    };

    return roleMapping[user.roles.role] || '';
  }

}
